import api from './axiosInstance';

export const getHotLeadsApi     = (params) => api.get('/crm/leads/hot', { params });
export const saveCallFeedbackApi = (data)  => api.post('/crm/call-feedback', data);
export const getCallHistoryApi  = (userId) => api.get(`/crm/call-history/${userId}`);
export const getFollowUpsApi    = ()       => api.get('/crm/follow-ups');
export const getLeadDetailApi   = (id)     => api.get(`/crm/lead/${id}`);
